const projects = [
    {
      id: "lorong-n-telok-kurau",
      title: "Lorong N Telok Kurau",
      type: "RESIDENTIAL",
      thumbnail: `/images/Lorong N Telok Kurau/Living View 2.jpeg`,
      imagesInfo: [
        { src: "/images/Lorong N Telok Kurau/79C Day View front.jpeg", alt: "79C Day View front" },
        { src: "/images/Lorong N Telok Kurau/79C Day View rear.jpeg", alt: "79C Day View rear" },
        { src: "/images/Lorong N Telok Kurau/Living View 2.jpeg", alt: "Living View 2" },
        { src: "/images/Lorong N Telok Kurau/Masterbedroom.jpeg", alt: "Masterbedroom" },
      ],
      status: "Completed 2022",
      scopeWord: ["Architecture", "Interior design"]
    },
    {
      id: "tuas-south-ave-16-plg",
      title: "Tuas South Ave 16-PLG",
      type: "INDUSTRIAL",
      thumbnail: "/images/Tuas South Ave 16-PLG/intro.jpg",
      imagesInfo: [
        { src: "/images/Tuas South Ave 16-PLG/171124_conference room.jpg", alt: "Conference Room" },
        { src: "/images/Tuas South Ave 16-PLG/171124_EXECUTIVE toilet.jpg", alt: "Executive Toilet" },
        { src: "/images/Tuas South Ave 16-PLG/171124_LIFT LOBBY 1.jpg", alt: "Lift Lobby 1" },
        { src: "/images/Tuas South Ave 16-PLG/171124_LIFT LOBBY 6.jpg", alt: "Lift Lobby 6" },
        { src: "/images/Tuas South Ave 16-PLG/171124_MANAGER.jpg", alt: "Manager Office" },
        { src: "/images/Tuas South Ave 16-PLG/171124_PANTRY.jpg", alt: "Pantry" },
        { src: "/images/Tuas South Ave 16-PLG/171124_reception.jpg", alt: "Reception" },
        { src: "/images/Tuas South Ave 16-PLG/171124_WORK STATION.jpg", alt: "Work Station" },
        { src: "/images/Tuas South Ave 16-PLG/TSA16_1_170803.jpg", alt: "TSA16 1" },
        { src: "/images/Tuas South Ave 16-PLG/TSA16_3_170803.jpg", alt: "TSA16 3" },
        { src: "/images/Tuas South Ave 16-PLG/TSA16_4_170807.jpg", alt: "TSA16 4" },
      ],
      status: "Completed 2021",
      scopeWord: ["Architecture, Interior Design"]
    },
    {
      id: "richards-avenue-33",
      title: "Richards Avenue -33",
      type: "RESIDENTIAL",
      thumbnail: `/images/Richards Avenue -33/intro.png`,
      imagesInfo: [
        { src: "/images/Richards Avenue -33/intro.png", alt: "Richards Avenue -33" },
      ],
      status: "In progress",
      scopeWord: ["Architecture"]
    },
    {
      id: "teo-hock-7",
      title: "Teo Hock 7",
      type: "RESIDENTIAL",
      thumbnail: `/images/Teo Hock 7/intro.jpg`,
      imagesInfo: [
        { src: "/images/Teo Hock 7/dining_room.jpg", alt: "Dining Room" },
      ],
      status: "Completed",
      scopeWord: ["Architecture, Interior Design"]
    },
  ];
  
  export default projects;